import { useContext } from 'react';
import { useTreatments, SplitContext } from '@splitsoftware/splitio-react';

const SPLITIO_FEATURE_NAME = 'atc_pagebuilder_popup_survey';
const SPLITIO_CONTROL_TREATMENT_KEY = 'on';

export function usePopupSurvey() {
  const { isReady } = useContext(SplitContext);

  const treatments = useTreatments([SPLITIO_FEATURE_NAME]);
  const { treatment } = treatments[SPLITIO_FEATURE_NAME];

  return {
    isReady,
    isActive: treatment === SPLITIO_CONTROL_TREATMENT_KEY,
  };
}
